import React, { useEffect, useRef } from 'react'
interface Props {
  name: string
  value: string
  setValue: (name: string, value: string, options?: any) => void
  watch: any
  register: any
  length?: number
  error?: string
}

const OtpInput: React.FC<Props> = ({
  name,
  value = '',
  setValue,
  register,
  length = 6,
  watch,
}) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([])

  useEffect(() => {
    inputRefs.current[0]?.focus()
  }, [])

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const inputVal = e.target.value.replace(/\D/g, '')
    if (!inputVal) return
    const current = (watch(name) || '').padEnd(length, '').split('')
    current[index] = inputVal[0]
    const newValue = current.join('')
    setValue(name, newValue, { shouldValidate: true })
    if (index < length - 1) {
      inputRefs.current[index + 1]?.focus()
    }
  }

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    i: number
  ) => {
    const chars = value.split('')
    if (e.key === 'Backspace') {
      if (chars[i]) {
        chars[i] = ''
        setValue(name, chars.join(''), { shouldValidate: true })
      } else if (i > 0) {
        inputRefs.current[i - 1]?.focus()
      }
    }
    if (e.key === 'Tab' && e.shiftKey && i > 0) {
      e.preventDefault()
      inputRefs.current[i - 1]?.focus()
    }
  }

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    const pasted = e.clipboardData
      .getData('text')
      .replace(/\D/g, '')
      .slice(0, length)
    const newValue = pasted.padEnd(length, '')
    setValue(name, newValue, { shouldValidate: true })
    const next = Math.min(pasted.length, length - 1)
    inputRefs.current[next]?.focus()
  }

  const currentValue = watch(name) || ''.padEnd(length, '')

  return (
    <>
      <input type="hidden" {...register(name)} />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${length}, 1fr)`,
          gap: '10px',
          width: '90%',
          margin: '0 auto',
        }}
      >
        {Array.from({ length }).map((_, i) => (
          <input
            key={i}
            ref={(el) => (inputRefs.current[i] = el)}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="\d*"
            maxLength={1}
            value={currentValue[i] || ''}
            onChange={(e) => handleChange(e, i)}
            onKeyDown={(e) => handleKeyDown(e, i)}
            onPaste={handlePaste}
            style={{
              width: '100%',
              height: '4rem',
              fontSize: '1.5rem',
              textAlign: 'center',
              border: '1px solid #ccc',
              borderRadius: '8px',
            }}
          />
        ))}
      </div>
    </>
  )
}

export default OtpInput
